import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { discharge } from "@/Services/TherapyApi/Clients";

import usePatientsStore from "@/Modules/Patients/Store";
import useAppStore from "@/Modules/App/Store";

async function dischargePatientAH(uuid: string, reason: string): Promise<boolean> {
  const appStore = useAppStore();
  const patientsStore = usePatientsStore();

  try {
    await discharge(uuid, reason);

    appStore.showSnackbar({
      type: NotificationType.INFO,
      message: "user.settings.customer.patient_discharge.notification_success_toast",
      messageParameters: { username: patientsStore.selected?.username },
    });

    return true;
  } catch (error: unknown) {
    appStore.showSnackbar({
      message: "patients.connection_notice.error",
      type: NotificationType.ERROR,
    });

    return false;
  } finally {
    patientsStore.isLoading = false;
  }
}

export default dischargePatientAH;
